"use strict";

exports.__esModule = true;
exports.sortLegendStates = exports.getStateDurationsFromData = exports.getFormattedValue = exports.enrichAndArrangeState = exports.UtilizationChartDataFormatter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Utils = require("../../../Utils");
var _stateDetails = require("./stateDetails");
var _StackedBar = require("../common/AggregateMetricCharts/StackedBar");
var _BarChart = require("../common/AggregateMetricCharts/BarChart");
var _Metrics = require("../../../Catalogs/Metrics");
var _TimeContext = require("../../Time/TimeContext");
var _sortEventsByWorkdayStart = require("../common/utils/sortEventsByWorkdayStart");
var _formatToPlantTime = require("../common/utils/formatToPlantTime");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _getUniqueTimestamps = require("../common/utils/getUniqueTimestamps");
var _tooltipStyles = require("../common/styles/tooltipStyles");
var _KeyColorWrapper = require("../common/styles/KeyColorWrapper");
var _tooltipSort = require("../common/tooltipSort");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getFormattedValue = exports.getFormattedValue = function getFormattedValue(metricUnit, value) {
  switch (metricUnit) {
    case "FRACTIONAL_PERCENT":
      return value ? (value * 100).toFixed(2) + "%" : "0%";
    case "MILLISECOND":
      return (0, _Utils.formatDuration)(value);
    default:
      return value;
  }
};
var getTooltip = function getTooltip(devices, tooltipSort) {
  if (tooltipSort === void 0) {
    tooltipSort = _tooltipSort.TOOLTIP_SORT_DESC;
  }
  return function (item) {
    var states = (0, _tooltipSort.sortTooltipItems)(item.value, _stateDetails.stateDetails, tooltipSort);
    return /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipTable, {
      "data-testid": "UtilizationChart.Tooltip"
    }, (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement("thead", {
      "data-testid": "UtilizationChart.Tooltip.header"
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipRow, null, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "left",
      width: 15
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "left",
      width: 130
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TextValue, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "Tooltip.totalOfDevices",
      defaultMessage: "Total devices selected"
    }))), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 30
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 70
    }), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
      align: "right",
      width: 15
    }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
      bold: true
    }, "" + devices.length.toFixed(0))))), /*#__PURE__*/_react["default"].createElement("tbody", null, states.map(function (state) {
      var stateData = _stateDetails.stateDetails.find(function (v) {
        return v.key === state.key;
      });
      return /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipRow, {
        key: state.key,
        "data-testid": "UtilizationChart.Tooltip.row." + state.key
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "left",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.ColorBlock, {
        color: stateData && stateData.color
      })), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "left",
        width: 130
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TextValue, null, stateData && stateData.name)), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "right",
        width: 30
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
        bold: true
      }, state.value.toFixed(2) + "%")), /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "left"
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TextValue, {
        bold: true
      }, getFormattedValue("MILLISECOND", state.duration))), (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement(_tooltipStyles.TooltipCell, {
        align: "right",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(_tooltipStyles.Value, {
        bold: true
      }, "" + state.devices.length.toFixed(0))));
    })));
  };
};
var getStateDurationsFromData = exports.getStateDurationsFromData = function getStateDurationsFromData(data) {
  if (data === void 0) {
    data = [];
  }
  return data.reduce(function (acc, doc) {
    acc[doc.state] = (acc[doc.state] || 0) + (doc.duration_sum || 0);
    return acc;
  }, {});
};
var sortLegendStates = exports.sortLegendStates = function sortLegendStates(states, data, tooltipSort) {
  if (states === void 0) {
    states = [];
  }
  if (data === void 0) {
    data = [];
  }
  if (tooltipSort === void 0) {
    tooltipSort = _tooltipSort.TOOLTIP_SORT_DESC;
  }
  var durations = getStateDurationsFromData(data);
  return (0, _tooltipSort.sortTooltipItems)(states.map(function (state) {
    return Object.assign({}, state, {
      duration: durations[state.key] || 0
    });
  }), states, tooltipSort);
};
var enrichAndArrangeState = exports.enrichAndArrangeState = function enrichAndArrangeState(statesData) {
  return _stateDetails.stateDetails.map(function (state) {
    var originalStateData = statesData.find(function (v) {
      return v.key === state.key;
    });
    if (originalStateData) {
      return originalStateData;
    } else {
      var _state$devices;
      return {
        devices: (_state$devices = state.devices) != null ? _state$devices : [],
        key: state.key,
        value: 0
      };
    }
  });
};
var formatStates = function formatStates(_ref) {
  var states = _ref.states,
    timestamp = _ref.timestamp,
    selectedStates = _ref.selectedStates,
    _ref$tooltipSort = _ref.tooltipSort,
    tooltipSort = _ref$tooltipSort === void 0 ? _tooltipSort.TOOLTIP_SORT_DESC : _ref$tooltipSort;
  var totalOfStates = states.reduce(function (acc, _ref2) {
    var value = _ref2.value;
    return acc += value;
  }, 0) || 1;
  var by_state = enrichAndArrangeState(states);
  by_state = by_state.map(function (v) {
    return {
      key: v.key,
      value: v.value * 100 / totalOfStates,
      duration: v.value,
      devices: v.devices
    };
  });
  by_state = by_state.filter(function (v) {
    return selectedStates.includes(v.key);
  });
  return {
    key: timestamp,
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_StackedBar.StackedBar, props);
    },
    value: (0, _tooltipSort.sortTooltipItems)(by_state, _stateDetails.stateDetails, tooltipSort)
  };
};
var createSeries = function createSeries(_ref3, _ref4) {
  var data = _ref3.data,
    selectedStates = _ref3.selectedStates,
    timeAggregationName = _ref3.timeAggregationName,
    devices = _ref3.devices,
    tooltipSort = _ref3.tooltipSort;
  var currentWorkday = _ref4.currentWorkday,
    timezone = _ref4.timezone;
  if (data.length === 0) {
    return {
      series: [],
      totalMinorBar: 0
    };
  }
  var timeBinName = (0, _timeAggregationBinMapping.getTimeGroupingBinName)(timeAggregationName).replace("by_", "");
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_PER_DAY) {
    data = (0, _formatToPlantTime.formatToPlantTime)({
      data: data,
      timezone: timezone,
      binName: timeBinName
    });
  }
  var timestamps = (0, _getUniqueTimestamps.getUniqueTimestamps)({
    data: data,
    binName: timeBinName
  });
  var seriesData = timestamps.map(function (timestamp) {
    var by_state = data.reduce(function (states, doc) {
      var state = doc.state;
      if (timestamp === doc[timeBinName]) {
        if (!states[state]) {
          var _Object$assign;
          return Object.assign({}, states, (_Object$assign = {}, _Object$assign[state] = {
            key: doc["state"],
            value: doc["duration_sum"],
            devices: [doc["device"]]
          }, _Object$assign));
        }
        states[state].value += doc["duration_sum"];
        states[state].devices.push(doc["device"]);
      }
      return states;
    }, {});
    by_state = Object.values(by_state);
    return formatStates({
      timestamp: timestamp,
      states: by_state,
      selectedStates: selectedStates,
      tooltipSort: tooltipSort
    });
  });
  if (timeAggregationName === _timeAggregationBinMapping.HOUR_OF_DAY) {
    seriesData = (0, _sortEventsByWorkdayStart.sortEventsByWorkdayStart)(seriesData, timezone.name, currentWorkday.interval.startMillis);
  } else {
    seriesData.sort(function (a, b) {
      return new Date(a.key).getTime() > new Date(b.key).getTime() ? 1 : -1;
    });
  }
  var metric = (0, _Metrics.getMetricDefinition)("utilization");
  var series = [{
    metricName: metric.name,
    unit: metric.units,
    color: metric.color,
    data: seriesData,
    getXValue: function getXValue(item) {
      return item.key;
    },
    getYValue: function getYValue(item) {
      return item.value;
    },
    getTooltip: getTooltip(devices, tooltipSort),
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_BarChart.BarChart, props);
    }
  }];
  return {
    series: series,
    totalMinorBar: 1
  };
};
var UtilizationChartDataFormatter = exports.UtilizationChartDataFormatter = function UtilizationChartDataFormatter(props) {
  var timeProps = _react["default"].useContext(_TimeContext.TimeContext);
  var _createSeries = createSeries(props, timeProps),
    series = _createSeries.series,
    totalMinorBar = _createSeries.totalMinorBar;
  return /*#__PURE__*/_react["default"].createElement(_KeyColorWrapper.KeyColorWrapper, {
    keyColorArray: _stateDetails.stateDetails
  }, props.children({
    series: series,
    totalMinorBar: totalMinorBar
  }));
};